import { render, staticRenderFns } from "./profitRanking.vue?vue&type=template&id=1dd865de&scoped=true"
import script from "./profitRanking.vue?vue&type=script&lang=js"
export * from "./profitRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd865de",
  null
  
)

export default component.exports